export default {

	init() {
		console.log('init nav...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		const header = document.querySelector('.site-header');
        const toggle = document.querySelector('.menu-toggle');
        const menu = document.querySelector('.header-menu');

        Nav.header = header;
        Nav.navToggle = toggle;
        Nav.navMenu = menu;

		if (!menu) {
			return;
		}

		toggle.addEventListener('click', Nav.toggleNav);
	},

	toggleNav(e) {
        if (Nav.navMenu.classList.contains('is-open')) {
            Nav.closeNav();
        } else {
            Nav.openNav();
        }
    },

	openNav() {
        document.querySelector('html').classList.add('is-nav-open');
        Nav.navMenu.classList.add('is-open', 'show');
		Nav.navToggle.classList.add('is-opening');
        Nav.navToggle.setAttribute('aria-expanded', 'true');

		let backdrop = document.createElement('div');
		backdrop.classList.add('sh-backdrop', 'is-open');
		Nav.header.insertAdjacentElement('afterend', backdrop);

		window.requestAnimationFrame(() => {
			backdrop.classList.add('show');
		});

		setTimeout(function() {
			Nav.navToggle.classList.remove('is-opening');
		}, 500);

		Nav.addCloseListeners();
    },

    closeNav() {
        Nav.navMenu.classList.add('is-closing');
		Nav.navToggle.classList.add('is-closing');
		Nav.navToggle.blur();

		let backdrop = document.querySelector('.sh-backdrop');
		backdrop.classList.remove('show');

		setTimeout(function() {
			document.querySelector('html').classList.remove('is-nav-open');
			Nav.navMenu.classList.remove('is-open', 'show', 'is-closing');
			Nav.navToggle.setAttribute('aria-expanded', 'false');
			Nav.navToggle.classList.remove('is-closing');
			backdrop.remove();
		}, 500);

		Nav.removeCloseListeners();
    },

	addCloseListeners() {
		let backdrop = document.querySelector('.sh-backdrop');

		backdrop.addEventListener('click', Nav.closeNav);
		document.addEventListener('keyup', Nav.escapeKey);
	},

	removeCloseListeners() {
		let backdrop = document.querySelector('.sh-backdrop');

		backdrop.removeEventListener('click', Nav.closeNav);
		document.removeEventListener('keyup', Nav.escapeKey);
	},

	escapeKey(e) {
		if (e.keyCode === 27) {
			Nav.closeNav();
		}
	},
};
